import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import CaseCountDisplay from 'Components/CaseCountDisplay/CaseCountDisplay.jsx';
import { connect } from 'react-redux';
import GDTableHeader from './GDTableHeader';
import GDTableFooter from './GDTableFooter';
import GDTableContainer from './GDTableContainer';
import GDTableSummaryRow from './GDTableSummaryRow';
import './GDTable.scss';
import AgGridTable from '../AgGridTable/AgGridTable';
import { flushSync } from 'react-dom';

class GDTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: this.selectVisibleColumns(
        this.props.report.dataColumns,
      ),
      selectedFileType: {},
      selectedExportType: {},
      detailViewAction: {
        name: this.props.translations.viewDetail,
        description: 'view detail description',
        linkedReportId: 'detail-view',
        linkedReportKey: '',
        actionType: 'ROW',
        reportLinks: [],
      },
    };
    this.attachBindings();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.report !== this.props.report && newProps.report.dataColumns) {
      this.setState({
        visibleColumns: this.selectVisibleColumns(
          newProps.report.dataColumns,
        ),
      });
    }
  }

  attachBindings() {
    this.selectOption = this.selectOption.bind(this);
    this.updateVisibleColumns = this.updateVisibleColumns.bind(this);
    this.selectVisibleColumns = this.selectVisibleColumns.bind(this);
  }

  selectOption(event, option) {
    this.setState({ [event.target.name]: option });
  }

  updateVisibleColumns(columns) {
    const newVisibleColumns = this.selectVisibleColumns(columns);
    flushSync(() => {
          this.setState({ visibleColumns: this.props.addIconsToGDTableHeadersList(newVisibleColumns,this.props.userPermissions) });
    });
    this.props.saveCurrentlyVisibleColumns(newVisibleColumns); // still save the list with hidden columns present

  }

  selectVisibleColumns(columns = []) {
    const isUserHasSelectedColumn = columns.filter((column) => {
      return (column.userIsVisible === true || column.isSelected === true) && column.description !== '' && column.displayType !== 'ICON';
    });
    return columns
      .filter((column) => {
        return (isUserHasSelectedColumn.length > 0 ? column.userIsVisible || column.isSelected : column.defaultIsVisible) && column.displayType !== 'NONE' && column.displayType !== 'EXPORT_ONLY';
      })
      .sort((columnA, columnB) => {
        return Number(columnA.displayOrder) - Number(columnB.displayOrder);
      });
  }

  render() {
    const { detailViewAction } = this.state;
    const wrapperClass = classnames(`gd-table ${this.props.reportName == "Unresolved RTI" ? "scroll-Y" : ""}`, {
      [this.props.extraClass]: this.props.extraClass,
    });
    const rowActions = this.props.report.columnToFilterMaps
      && this.props.report.columnToFilterMaps.length
      ? this.props.report.columnToFilterMaps.map((action) => {
        const uniqueKey = action.reportColumnLinks.reduce((accumulator, item) => {
          return `${accumulator}_${item.toFilterId}`;
        }, '');

        return {
          callback: (rowId) => {
            const rowToUse = this.props.data.find((row) => row['seq_key'] === rowId); // eslint-disable-line

            if (rowToUse) {
              this.props.handleRowAction({ row: rowToUse, action });
            }
          },
          id: uniqueKey,
          text: action.name,
          primary: false,
        };
      })
      : [];

    rowActions.unshift({
      callback: (rowId) => {
        const rowDetail = this.props.data.find((row) => {
          return row.seq_key === rowId;
        });
        this.props.onRowClick(null, rowDetail);
      },
      id: `${detailViewAction.linkedReportId}`,
      text: `${detailViewAction.name}`,
      primary: true,
    });

    return (
      <div className={`${this.props.tableCss} ${wrapperClass}`} style={this.props.reportName == 'MRE' ? {width: "104%"} : {}}>
        {this.props.report.dataColumns && this.props.report.dataColumns?.length > 0 && (
          <GDTableHeader
            {...this.props}
            title={this.props.report.name}
            tableName={this.props.tableName}
            merchantDetail={this.props.merchantDetail}
            titleRequired={this.props.titleRequired}
            informationBubbleText={this.props.report.informationBubbleText}
            columns={this.props.report.dataColumns}
            exporting={this.props.exporting}
            totalRecords={this.props.totalRecords}
            recordsCountText={this.props.recordsCountText}
            currentPage={this.props.currentPage}
            recordsShown={this.props.recordsShown}
            filterText={this.props.filterText}
            onSearchChange={this.props.onSearchChange}
            canSearch={this.props.report.canSearch}
            isNextPage={this.props.isNextPage}
            canExport={this.props.report.isExportable}
            exportAction={this.props.exportAction}
            toggleFileExport={this.props.toggleFileExport}
            filterExportIsVisible={this.props.filterExportIsVisible}
            selectOption={this.selectOption}
            selectedFileType={this.state.selectedFileType}
            selectedExportType={this.state.selectedExportType}
            translations={this.props.translations}
            canManageColumns={
              this.props.report.canManageColumns
            }
            updateVisibleColumns={this.updateVisibleColumns}
            dateFormat={this.props.dateFormat}
            timeBoxData={this.props.timeBoxData}
            refreshTimeFeed={this.props.refreshTimeFeed}
            recordCountRequired={this.props.recordCountRequired}
            routeToPreviousPage={this.props.routeToPreviousPage}
            showBackToReport={this.props.showBackToReport}
            exportFileName={this.props.exportFileName}
            queueDesc={this.props.queueDesc}
            userActiveRuleCount = {this.props.userActiveRuleCount}
            userInactiveRuleCount = {this.props.userInactiveRuleCount}
            otherInactiveRuleCount = {this.props.otherInactiveRuleCount}
            otherActiveRuleCount = {this.props.otherActiveRuleCount}
            isMyruleTable = {this.props.isMyruleTable}
            isOtherExistingRuleTable = {this.props.isOtherExistingRuleTable}
          />
        )}
        {this.props.isFetchingData &&<BVLoader20 />}
        {!this.props.isFetchingData && this.props.hasSummaryRow && (
          <GDTableSummaryRow
            title={this.props.translations.summaryTitle}
            summaryColumns={this.props.report.summaryColumns}
            summaryData={this.props.summaryData}
            currencyCode={this.props.selectedCurrencyCode}
            id={this.props.report.name}
          />
        )}
        {this.props.showCaseCountDisplay && (
          <CaseCountDisplay
            dataColumns={this.props.headerCountDataColumn}
            caseCountData={this.props.headerCountData}
          />
        )}
        {!this.props.isFetchingData && (
          <div className="gd-table__main-container" >
            { this.props.isAgGrid &&
            <AgGridTable
              actionWidth={this.props.actionWidth}
              actions={this.props.report.actions}
              agLoader={this.props.agLoader}
              appSerchUrl={this.props.appSerchUrl}
              appliedFilterParams={this.props.appliedFilterParams}
              archiveUnmatchedSchemeImage={this.props.archiveUnmatchedSchemeImage}
              bookMarkedRows={this.props.bookMarkedRows}
              caseStageId={this.props.caseStageId}
              columns={this.state.visibleColumns}
              currentPage={this.props.currentPage}
              dateFormat={this.props.dateFormat}
              deleteNotification={this.props.deleteNotification}
              filterTypeId ={this.props.filterTypeId}
              getFormattedData={this.props.getFormattedData}
              getMerchantActions={this.props.getMerchantActions}
              globalToken={this.props.globalToken}
              handleSort={this.props.handleSort}
              id={`${this.props.report.name}_GDTableFooter`}
              isArchival={this.props.isArchival}
              isAutoHeight={this.props.isAutoHeight}
              isCellborder={this.props?.isCellborder}
              isCheckboxOnRowRequired={this.props.isCheckboxOnRowRequired}
              isGridCompact={this.props?.isGridCompact}
              isLocalSort={this.props.isLocalSort}
              isMerchantPortal={this.props.isMerchantPortal}
              isMerchatActions={this.props.isMerchatActions}
              isNewQueueLanding={this.props.isNewQueueLanding}
              isNextPage={this.props.isNextPage}
              isPagable={this.props.isPagable}
              isRefreshed={this.props.isRefreshed}
              isTransactionFlag={this.props.isTransactionFlag}
              isVisible={this.props.isVisible}
              lazyLoadPageNumber ={this.props.lazyLoadPageNumber}
              onBookMarked={this.props.onBookMarked}
              onCheckboxClick={this.props.onCheckboxClick}
              onCloseClick={this.props.onCloseClick} 
              openBoxDropDownStyle={this.props.openBoxDropDownStyle}
              pageHandler={this.props.pageHandler}
              pageListId={this.props.pageListId}
              pageName={this.props.pageName}
              queueId = {this.props.queueId}
              recordsCountText={this.props.recordsCountText}
              recordsShown={this.props.recordsShown}
              regionCode={this.props.regionCode}
              reportName={this.props.reportName}
              rowActionClick={this.props.rowActionClick} 
              rowActions={rowActions}
              rowData={this.props.data}
              selectedRows={this.props.selectedRows}
              serverSideData={this.props.serverSideData}
              setAggridCaseData={this.props.setAggridCaseData}
              setDataError={this.props.setDataError}
              setFilterModelAttribute={this.props.setFilterModelAttribute}
              setRecordCount ={this.props.setRecordCount}
              sort={this.props.sort}
              timeFormat={this.props.timeFormat}
              totalPages={this.props.totalPages}
              totalRecords={this.props.totalRecords}
              translations={this.props.translations}
              triggerText={this.props.actionButtonText}
              user={this.props.user}
              rowHeight={this.props.rowHeight}
              />
              }
            {!this.props.isAgGrid && <GDTableContainer
              tableName={this.props.tableName}
              user={this.props.user}
              identifier={this.props.report.primaryColumnKey}
              extraClass={this.props.className}
              actionButtonText={this.props.actionButtonText}
              columns={this.state.visibleColumns}
              data={this.props.data}
              dateFormat={this.props.dateFormat}
              timeFormat={this.props.timeFormat}
              sort={this.props.sort}
              handleRowAction={this.props.handleRowAction}
              handleSort={this.props.handleSort}
              rowActions={rowActions}
              onRowClick={this.props.onRowClick}
              exportFileName={this.props.report.name}
              actions={this.props.report.actions}
              rowActionClick={this.props.rowActionClick}
              loadDataOnScroll={this.props.loadDataOnScroll}
              isPagable={this.props.isPagable}
              openBoxDropDownStyle={this.props.openBoxDropDownStyle}
              isLoading={this.props.isLoading}
              isCheckboxOnRowRequired={this.props.isCheckboxOnRowRequired}
              onCheckboxClick={this.props.onCheckboxClick}
              selectedRows={this.props.selectedRows}
              dragOvertText={this.props.dragOvertText}
              onBookMarked={this.props.onBookMarked}
              bookMarkedRows={this.props.bookMarkedRows}
              isReport={this.props.isReport}
              onToggleChange={this.props.onToggleChange}
              updateRulePriority = {this.props.updateRulePriority}
              reportName={this.props.reportName}
              translations={this.props.translations}
              disableRulePriorityArrows = {this.props.disableRulePriorityArrows}
              isMerchatActions={this.props.isMerchatActions}
              isActionOpen = {this.props.isActionOpen}
              isActionClick = {this.props.isActionClick}
              createMREAccess = {this.props.createMREAccess}
            />}
            {this.props.showFooter && this.props.isPagable && (
              <GDTableFooter
                totalRecords={this.props.totalRecords}
                totalPages={this.props.totalPages}
                recordsCountText={this.props.recordsCountText}
                currentPage={this.props.currentPage}
                recordsShown={this.props.recordsShown}
                pageHandler={this.props.pageHandler}
                translations={this.props.translations}
                isNextPage={this.props.isNextPage}
                id={`${this.props.report.name}_GDTableFooter`}
                isPagable={this.props.isPagable}
              />
            )
            }
          </div>
        )}
      </div>
    );
  }                                           
}

GDTable.propTypes = {
  addIconsToGDTableHeadersList: PropTypes.func,
  canSearch: PropTypes.bool,
  createMREAccess: PropTypes.bool,
  currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  data: PropTypes.array.isRequired,
  dateFormat: PropTypes.string.isRequired,
  disableRulePriorityArrows: PropTypes.bool,
  dragOvertText: PropTypes.string,
  exportAction: PropTypes.func,
  exportFileName: PropTypes.string,
  exporting: PropTypes.bool,
  extraClass: PropTypes.string,
  filterExportIsVisible: PropTypes.bool,
  filterText: PropTypes.string,
  handleRowAction: PropTypes.func,
  handleSort: PropTypes.func, // generalize to refresh API call with new sort param
  hasSummaryRow: PropTypes.bool, // if GET /reports/:reportId/summary returns anything
  headerCountData: PropTypes.object,
  headerCountDataColumn: PropTypes.array,
  informationBubbleText: PropTypes.string,
  isActionClick: PropTypes.bool,
  isActionOpen: PropTypes.bool,
  isAgGrid:PropTypes.bool,
  isCellborder: PropTypes.bool,
  isCheckboxOnRowRequired: PropTypes.bool,
  isFetchingData: PropTypes.bool,
  isGridCompact: PropTypes.bool,
  isLocalSort: PropTypes.bool,
  isMerchatActions: PropTypes.bool,
  isNewQueueLanding: PropTypes.bool,
  isNextPage: PropTypes.bool,
  isPagable: PropTypes.bool.isRequired,
  loadDataOnScroll: PropTypes.func,
  merchantDetail: PropTypes.object,
  onBookMarked: PropTypes.func,
  onCheckboxClick: PropTypes.func,
  onCloseClick: PropTypes.bool,
  onRowClick: PropTypes.func,
  onRowClickDownload: PropTypes.func,
  onSearchChange: PropTypes.func,
  onToggleChange: PropTypes.func,
  pageHandler: PropTypes.func.isRequired,
  recordsCountText: PropTypes.object.isRequired,
  recordsShown: PropTypes.number,
  report: PropTypes.object.isRequired,
  reportName: PropTypes.string,
  rowActionClick: PropTypes.func,
  rowHeight: PropTypes.number,
  saveCurrentlyVisibleColumns: PropTypes.func,
  selectedCurrencyCode: PropTypes.string,
  selectedRows: PropTypes.array,
  showCaseCountDisplay: PropTypes.bool,
  sort: PropTypes.array.isRequired,
  summaryData: PropTypes.array,
  tableName: PropTypes.string,
  timeBoxData: PropTypes.object,
  timeFormat: PropTypes.string,
  titleRequired: PropTypes.bool,
  toggleFileExport: PropTypes.func,
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  translations: PropTypes.object.isRequired,
  updateRulePriority: PropTypes.func,
};

GDTable.defaultProps = {
  addIconsToGDTableHeadersList: () => { },
  canSearch: false,
  createMREAccess: false,
  disableRulePriorityArrows: false,
  dragOvertText: '',
  exportAction: null,
  exportFileName: '',
  exporting: false,
  extraClass: '',
  filterExportIsVisible: false,
  filterText: '',
  handleRowAction: null,
  handleSort: () => { },
  hasSummaryRow: false,
  headerCountData: {},
  headerCountDataColumn: [],
  informationBubbleText: '',
  isActionClick: false,
  isActionOpen: true,
  isAgGrid:false,
  isCellborder: false,
  isCheckboxOnRowRequired: false,
  isFetchingData: false,
  isGridCompact: false,
  isLocalSort: false,
  isMerchatActions: false,
  isMyruleTable : false,
  isNewQueueLanding: false,
  isNextPage: false,
  isOtherExistingRuleTable : false,
  isPagable: false,
  loadDataOnScroll: () => { },
  merchantDetail: null,
  onCloseClick: false,
  onRowClick: () => { },
  onRowClickDownload: () => { },
  onSearchChange: () => { },
  onToggleChange: () => { },
  otherActiveRuleCount : 0,
  otherInactiveRuleCount :0,
  recordsShown: 25,
  reportName: '',
  rowActionClick: () => { },
  rowHeight: 50,
  saveCurrentlyVisibleColumns: () => { },
  selectedCurrencyCode: '',
  selectedRows: [],
  showCaseCountDisplay: false,
  showFooter: true,
  summaryData: [],
  tableCss: '',
  timeBoxData: {},
  titleRequired: true,
  toggleFileExport: () => { },
  updateRulePriority: () => { },
  userActiveRuleCount : 0,
  userInactiveRuleCount : 0,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(GDTable);
